import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles((surveyTheme: any) => ({
  anchorElement: {
    fontSize: 12,
    lineHeight: '18px',
    textDecoration: 'underline',
    display: 'block',
    textAlign: 'center',
    margin: '0 auto',
    color: surveyTheme.questionColor,
    fontFamily: 'National2,"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
}));

export default useStyles;
